import type { TRuleWithTheme } from '@/styles/theme';

// The pill is a tab anchored to the top-center edge of the records area: it
// hangs down from the top with rounded bottom corners and small concave
// fillets (::before/::after) that flare its top sides into the top edge.
export const pill: TRuleWithTheme = ({ theme }) => ({
    position: 'absolute',
    top: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 10,

    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(8),
    height: '32px',
    paddingLeft: theme.spacing(16),
    paddingRight: theme.spacing(4),

    borderBottomLeftRadius: '16px',
    borderBottomRightRadius: '16px',
    backgroundColor: theme.colors.accentPrimary,
    color: theme.colors.foregroundsOnPrimary,

    '::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: '-12px',
        width: '12px',
        height: '12px',
        background: `radial-gradient(circle at bottom left, transparent 12px, ${theme.colors.accentPrimary} 12px)`,
    },

    '::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        right: '-12px',
        width: '12px',
        height: '12px',
        background: `radial-gradient(circle at bottom right, transparent 12px, ${theme.colors.accentPrimary} 12px)`,
    },
});

export const label: TRuleWithTheme = ({ theme }) => ({
    fontFamily: theme.fontFamily,
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: '1rem',
    letterSpacing: '0.0125rem',
    color: theme.colors.foregroundsOnPrimary,
    whiteSpace: 'nowrap',
});

export const stopButton: TRuleWithTheme = ({ theme }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    height: '24px',
    paddingLeft: theme.spacing(12),
    paddingRight: theme.spacing(12),
    border: `1px solid ${theme.colors.foregroundsPrimary}`,
    borderRadius: '12px',
    backgroundColor: theme.colors.backgroundsSecondary,
    color: theme.colors.foregroundsPrimary,

    fontFamily: theme.fontFamily,
    fontSize: '0.75rem',
    fontWeight: 500,
    lineHeight: '1rem',
    letterSpacing: '0.0125rem',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
});
